module.exports = __webpack_public_path__ + "static/img/icon_sort_ascend.8ecc872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_sort_ascend.png
// module id = GY44
// module chunks = 31